import React from 'react';

import { usePriceChangeMarketReactionData } from '~/hooks/use-price-change-market-reaction-data/usePriceChangeMarketReactionData';
import { usePriceMarketReactionData } from '~/hooks/use-price-market-reaction-data/usePriceMarketReactionData';
import { MarketReactionChart } from '~/modules/market-reaction-charts/MarketReactionChart';
import { useEntities } from '~/react-query-hooks/entities/useEntities';

import * as S from './MarketCatalystReaction.styles';

export interface MarketCatalystReactionProps {
  tags: string[];
  tickers: string[];
  createdAt: string;
}

export const MarketCatalystReaction = ({
  tags,
  tickers,
  createdAt,
}: MarketCatalystReactionProps) => {
  const isMultipleETFs = tags.length > 1;
  const {
    priceData,
    fromDateEST,
    toDateEST,
    lastProportionChange,
    lastKnownPrice,
    prevCloseDate,
    lastKnownDate,
    isLoading: isPriceMarketReactionDataLoading,
  } = usePriceMarketReactionData({
    entityTag: tags[0],
    ticker: tickers[0],
    reportingDate: createdAt,
    isMultipleEntitiesChart: isMultipleETFs,
  });

  const { data: entitiesData } = useEntities({
    entityTags: tags,
    enabled: isMultipleETFs,
  });

  const {
    data: priceChangeData,
    isLoading: isPriceChangeMarketReactionDataLoading,
  } = usePriceChangeMarketReactionData({
    tags,
    tickers,
    fromDateEST,
    toDateEST,
    enabled: isMultipleETFs,
  });

  const isLoading =
    isPriceMarketReactionDataLoading || isPriceChangeMarketReactionDataLoading;

  const lines = isMultipleETFs
    ? priceChangeData
    : [
        {
          data: priceData,
          prevCloseDate,
          lastProportionChange,
          lastKnownPrice,
          lastKnownDate,
        },
      ];

  if (isLoading) {
    return <S.StyledSkeletonLoader />;
  }

  return (
    <MarketReactionChart
      fromDateEST={fromDateEST}
      toDateEST={toDateEST}
      lines={lines}
      entities={entitiesData}
    />
  );
};
